import api from "~/services/api";

type GetDocumentOptions = {
  includeLoginAccess?: boolean;
};

export const getDocument = async <T = any>(
  documentId: string,
  { includeLoginAccess = false }: GetDocumentOptions = {},
) =>
  api
    .get<T>(`/api/v1/documents/${documentId}`, {
      params: { include_login_access: includeLoginAccess },
    })
    .then(({ data }) => data);
